import { render, staticRenderFns } from "./BannerMtLinkSlider.vue?vue&type=template&id=24dd2461&scoped=true&"
import script from "./BannerMtLinkSlider.vue?vue&type=script&lang=js&"
export * from "./BannerMtLinkSlider.vue?vue&type=script&lang=js&"
import style0 from "./BannerMtLinkSlider.vue?vue&type=style&index=0&id=24dd2461&lang=scss&"
import style1 from "./BannerMtLinkSlider.vue?vue&type=style&index=1&id=24dd2461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd2461",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dd2461')) {
      api.createRecord('24dd2461', component.options)
    } else {
      api.reload('24dd2461', component.options)
    }
    module.hot.accept("./BannerMtLinkSlider.vue?vue&type=template&id=24dd2461&scoped=true&", function () {
      api.rerender('24dd2461', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/BannerMtLink/components/common/BannerMtLinkSlider.vue"
export default component.exports